export enum EnrichedUserDetailsFlow {
  showEmail = 0,
  showUserDetails = 1,
}
